import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { OperadoraProvider } from "./context/OperadoraContext";
import Landing from "./pages/Landing";
import Home from "./pages/Home";
import Documentos from "./pages/Documentos";
import Login from "./pages/Login";
import Cadastro from "./pages/Cadastro";
import UserAdmin from "./pages/UserAdmin";
import PrivateRoute from "./components/PrivateRoute";

// Qualquer rota não mapeada (ex: /dashboard, /admin, /pagina-inexistente) caía em tela
// completamente em branco, pois o <Routes> não tinha catch-all. Redireciona pro lugar
// certo em vez de deixar em branco: autenticado vai pro app, senão pro login.
function NotFoundRedirect() {
  const { isAuthenticated } = useAuth();
  return <Navigate to={isAuthenticated ? "/app" : "/login"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <OperadoraProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Cadastro />} />
            <Route path="/app" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/app/documentos" element={<PrivateRoute><Documentos /></PrivateRoute>} />
            <Route path="/app/usuarios" element={<PrivateRoute><UserAdmin /></PrivateRoute>} />
            <Route path="*" element={<NotFoundRedirect />} />
          </Routes>
        </Router>
      </OperadoraProvider>
    </AuthProvider>
  );
}

export default App;
